/**
 * @generated SignedSource<<dc6ab75833ac95a5bd11c78321098a26>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiDesignGenEditor_CreateOrUpdateMutation$variables = {
  customPrompt?: string | null;
  presetID?: number | null;
};
export type aiDesignGenEditor_CreateOrUpdateMutation$data = {
  readonly createOrUpdateDesignWithAISetting: {
    readonly customPrompt: string | null;
    readonly id: string;
    readonly presetID: number | null;
    readonly settingsID: number;
  };
};
export type aiDesignGenEditor_CreateOrUpdateMutation = {
  response: aiDesignGenEditor_CreateOrUpdateMutation$data;
  variables: aiDesignGenEditor_CreateOrUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customPrompt"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "presetID"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customPrompt",
        "variableName": "customPrompt"
      },
      {
        "kind": "Variable",
        "name": "presetID",
        "variableName": "presetID"
      }
    ],
    "concreteType": "DesignWithAISettingDTO",
    "kind": "LinkedField",
    "name": "createOrUpdateDesignWithAISetting",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "settingsID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "presetID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "customPrompt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiDesignGenEditor_CreateOrUpdateMutation",
    "selections": (v2/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "aiDesignGenEditor_CreateOrUpdateMutation",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "4b54f579c9445195e9f94586c0ca2a69",
    "id": null,
    "metadata": {},
    "name": "aiDesignGenEditor_CreateOrUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation aiDesignGenEditor_CreateOrUpdateMutation(\n  $presetID: Int\n  $customPrompt: String\n) {\n  createOrUpdateDesignWithAISetting(presetID: $presetID, customPrompt: $customPrompt) {\n    id\n    settingsID\n    presetID\n    customPrompt\n  }\n}\n"
  }
};
})();

(node as any).hash = "0d98d9570595b065d5ea4a596701e957";

export default node;
